import axios from 'axios';

class Api {
    constructor () {}

    call (requestType, url, data = null) {
        return axios[requestType](url, data);
    }
}

export default Api;
